<template>
    <div class="d-flex justify-content-center">
        <vertical-progress-bar
            :value="value"
            :variant="variant"
        />
        <div class="text-center">
            <div class="d-flex align-items-center justify-content-center">
                <response-emoji
                    :response="response"
                    size="30px"
                />
                <span
                    class="ml-2 text-18"
                >
                    {{ text }}
                </span>
            </div>
            <div
                style="
                    font-size: 2.5rem;
                    color: cornflowerblue;
                "
            >
                {{ value }}%
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VerticalBarChart',
    props: {
        text: {
            type: String,
            default: '',
        },
        value: {
            type: Number,
            default: 0,
        },
        variant: {
            type: String,
            default: 'success',
        },
    },
    computed: {
        response () {
            const variantMap = {
                danger: 0,
                warning: 1,
                success: 2,
                info: 3,
            }

            return variantMap[this.variant]
        },
    },
    components: {
        ResponseEmoji: () => import('@/components/Emojis/ResponseEmoji'),
        VerticalProgressBar: () => import('@/components/VerticalProgressBar/VerticalProgressBar'),
    },
}
</script>
